import { TypeGenerator } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


// 日期上指定的值
export function DATE_FETCH(args: IArgumentType[], token: IFunctionToken, argumentTypes: string[]) {
  const functionName = token.formatName;
  if (args.length !== 1) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的只接受一个参数`, token.position);
  }
  const argumentTypesText = argumentTypes.join(' 或 ');

  if (!argumentTypes.includes(args[0].type)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数必须为 ${argumentTypesText} 类型`, token.position);
  }

  return TypeGenerator.Integer();
}
